// extracted by mini-css-extract-plugin
module.exports = {"uploadWarning":"uploadWarning_uploadWarning__2D_y5","icon":"uploadWarning_icon__1mkBy","warning":"uploadWarning_warning__3DlhK"};